import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core'
import { form } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { arvonMuutokset } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'

interface GoogleSheetLomake {
  sheetLink: string
}

export interface AsiakasAsetuksetGoogleSheetLinkkiDialogData {
  sheetLink: string
}

@Component({
  selector: 'app-google-sheet-linkki-dialog',
  templateUrl: './google-sheet-linkki.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakasAsetuksetGoogleSheetLinkkiDialog implements OnInit {
  private readonly _injector = inject(Injector)

  lomake = form(signal<GoogleSheetLomake>({ sheetLink: this.data.sheetLink ?? '' }))

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: AsiakasAsetuksetGoogleSheetLinkkiDialogData,
    private dialogRef: MatDialogRef<AsiakasAsetuksetGoogleSheetLinkkiDialog>,
  ) {}

  ngOnInit() {
    arvonMuutokset(this.lomake.sheetLink, { injector: this._injector }).subscribe(value => {
      this.data.sheetLink = value
    })
  }

  tallenna() {
    if (!this.lomake().valid()) {
      return
    }
    // Varmistetaan, että linkissä aina oikea protokolla -> avautuu silloin <a> elementistä oikein omaan osoitteeseen
    if (this.data.sheetLink && !this.data.sheetLink.startsWith('https://') && !this.data.sheetLink.startsWith('http://')) {
      this.data.sheetLink = `https://${this.data.sheetLink.trim()}`
    }
    this.dialogRef.close(this.data)
  }
}
